/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/camelcase */
/** ============================ */
/*  This file was autogenerated  */
/*  with `npm run codegen`       */
/* ============================= */

import { gql } from "@apollo/client";
import * as ApolloReactCommon from "@apollo/client";
import * as ApolloReactHooks from "@apollo/client";

import * as Types from "../../../../api/types.generated";
export type DetailedMentorShiftsQueryVariables = Types.Exact<{
  where: Types.EventActivityWhereInput;
}>;

export type DetailedMentorShiftsQuery = {
  detailedMentorShifts: Array<
    Pick<
      Types.EventActivity,
      | "category"
      | "created_at"
      | "end_time"
      | "event_id"
      | "id"
      | "location"
      | "name"
      | "restrictions"
      | "start_time"
      | "updated_at"
      | "slug"
      | "restrictions_string"
    > & {
      shift_signups?: Types.Maybe<
        Array<{
          event_attendee: Pick<Types.EventAttendee, "id"> & {
            user: Pick<Types.User, "name">;
          };
        }>
      >;
    }
  >;
};

export const DetailedMentorShiftsDocument = gql`
  query DetailedMentorShifts($where: EventActivityWhereInput!) {
    detailedMentorShifts(where: $where) {
      category
      created_at
      end_time
      event_id
      id
      location
      name
      restrictions
      start_time
      updated_at
      slug
      restrictions_string
      shift_signups {
        event_attendee {
          id
          user {
            name
          }
        }
      }
    }
  }
`;

/**
 * __useDetailedMentorShiftsQuery__
 *
 * To run a query within a React component, call `useDetailedMentorShiftsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDetailedMentorShiftsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDetailedMentorShiftsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDetailedMentorShiftsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    DetailedMentorShiftsQuery,
    DetailedMentorShiftsQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<
    DetailedMentorShiftsQuery,
    DetailedMentorShiftsQueryVariables
  >(DetailedMentorShiftsDocument, baseOptions);
}
export function useDetailedMentorShiftsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    DetailedMentorShiftsQuery,
    DetailedMentorShiftsQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<
    DetailedMentorShiftsQuery,
    DetailedMentorShiftsQueryVariables
  >(DetailedMentorShiftsDocument, baseOptions);
}
export type DetailedMentorShiftsQueryHookResult = ReturnType<
  typeof useDetailedMentorShiftsQuery
>;
export type DetailedMentorShiftsLazyQueryHookResult = ReturnType<
  typeof useDetailedMentorShiftsLazyQuery
>;
export type DetailedMentorShiftsQueryResult = ApolloReactCommon.QueryResult<
  DetailedMentorShiftsQuery,
  DetailedMentorShiftsQueryVariables
>;
